import React from 'react';
import { render } from 'react-dom';
import {parseDataToProps} from "../../helpers";

const cartNodes = document.querySelectorAll('.cart');

if (cartNodes.length > 0) {
    import(/* webpackChunkName: "ObservingCart" */ './components/Cart').then(({ObservingCart: ObservingCart}) => {
        [...cartNodes].forEach((node) => render(<ObservingCart {...parseDataToProps(node.dataset)} />, node));
    });
}

const cartRelatedItemsNodes = document.querySelectorAll('.cart-related-items');

if (cartRelatedItemsNodes.length > 0) {
    import(/* webpackChunkName: "ObservingCartRelatedItems" */ './components/CartRelatedItems').then(({ObservingCartRelatedItems: ObservingCartRelatedItems}) => {
        [...cartRelatedItemsNodes].forEach((node) => render(<ObservingCartRelatedItems {...parseDataToProps(node.dataset)} />, node));
    });
}
